// extracted by mini-css-extract-plugin
module.exports = {"container":"Login_container__20uYt","version":"Login_version__l5aR-","content":"Login_content__1wjYQ"};